import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-594f5dd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-header-title is-capitalized" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = ["disabled", "onChange", "checked"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = ["for", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.sortedItems.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.name.replace('_', ' ')), 1),
          (_ctx.sortedItems.length > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "facet-sort has-text-right",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nameSort = !_ctx.nameSort))
              }, [
                _createElementVNode("a", null, _toDisplayString(_ctx.sortingOption), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedItems, ([value, count]) => {
            return (_openBlock(), _createElementBlock("div", { key: value }, [
              _createElementVNode("input", {
                type: "checkbox",
                disabled: _ctx.loading || undefined,
                onChange: ($event: any) => (_ctx.updateChecked(value, ($event.target as HTMLInputElement).checked)),
                checked: _ctx.modelValue === value
              }, null, 40, _hoisted_5),
              _hoisted_6,
              _createElementVNode("label", {
                for: value,
                title: value
              }, _toDisplayString(_ctx.truncateSelect(value)) + " (" + _toDisplayString(count) + ")", 9, _hoisted_7)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}